import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { ContentActionNotification, INotificationTranslationIds } from '../../ts/services/ContentActionNotification';
import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ServiceLocator } from '../../app/ServiceLocator';
import { toNativePromise } from '../../commonInfra/utils/QUtils';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';

function execute(extractTasks: Set<IExtractTaskInfo>): Promise<IResult> {

  let description: string;
  const extractTaskCount = extractTasks.size();

  if (extractTaskCount === 1) {
    const extractTask = extractTasks.first();
    if (extractTask.datasource) {
      description = Messages.extractTaskForDataSourceRunPrompt({DATASOURCE_NAME: L10n.elideIfLong(extractTask.datasource.name)
      });
    } else if (extractTask.workbook) {
      description = Messages.extractTaskForWorkbookRunPrompt({WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)});
    } else {
      description = Messages.extractTasksRunPrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
    }
  }

  else {
    description = Messages.extractTasksRunPrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
  }

  const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.runNow(),
      actionName: Messages.runNowConfirmButton(),
      action: () => ExtractTasks.run(extractTasks.keys()),
      message: description,
      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px
    });

  dialogConfig.result.then((result: IResult) => {
    const contentActionNotification = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');
    contentActionNotification.notifyResult(extractTasks,result.errors,notificationTranslationIds());
    });

  return toNativePromise(dialogConfig.result);

}

function notificationTranslationIds(): INotificationTranslationIds {
  return {
    successId: 'extractTasksRunSuccess',
    errorId: 'extractTasksRunError'
  };
}

export const RunExtractTasksAction = {
  execute
};

export type RunExtractTasksAction = typeof RunExtractTasksAction;



